import styled from 'styled-components';

import { PatientPregnant } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { dateFormatter, Translate } from '@dreryk/react-common';
import { StyledFlex, TextView } from '@dreryk/react-components';

import { gynecologicalInterviewTranslationKeys } from '../../../translations';

import { GynecologicalInterviewBasicPregnancyInfo } from './GynecologicalInterviewBasicPregnancyInfo';

type GynecologicalInterviewPatientPregnantInterviewProps = {
   readonly patientPregnantInterview: PatientPregnant;
};

const StyledDeterminedOnBasis = styled(TextView)`
   flex-basis: 245px;
`;

export const GynecologicalInterviewPatientPregnantInterview = (
   props: GynecologicalInterviewPatientPregnantInterviewProps
): JSX.Element => {
   return (
      <>
         <StyledFlex gap={'24px'} direction={'column'}>
            <StyledFlex gap={'24px'} justifyContent={'space-between'}>
               <TextView testId={'interviewType'} label={gynecologicalInterviewTranslationKeys.type}>
                  <Translate>{gynecologicalInterviewTranslationKeys.interviewType.PATIENT_PREGNANT}</Translate>
               </TextView>
               <GynecologicalInterviewBasicPregnancyInfo
                  confirmed={Boolean(props.patientPregnantInterview.pregnancyConfirmed)}
                  multiple={Boolean(props.patientPregnantInterview.multiplePregnancy)}
               />
            </StyledFlex>
            <StyledFlex justifyContent={'space-between'}>
               <TextView
                  testId={'predictedCompletionDate'}
                  label={gynecologicalInterviewTranslationKeys.predictedCompletionDate}
               >
                  {props.patientPregnantInterview.predictedCompletionDate
                     ? dateFormatter(props.patientPregnantInterview.predictedCompletionDate)
                     : '-'}
               </TextView>
               <StyledDeterminedOnBasis
                  testId={'determinedOnBasis'}
                  label={gynecologicalInterviewTranslationKeys.determinedOnBasis}
               >
                  {props.patientPregnantInterview.predictedCompletionBasis ? (
                     <Translate>
                        {
                           gynecologicalInterviewTranslationKeys.predictedCompletionDateBasis[
                              props.patientPregnantInterview.predictedCompletionBasis
                           ]
                        }
                     </Translate>
                  ) : (
                     '-'
                  )}
               </StyledDeterminedOnBasis>
            </StyledFlex>
         </StyledFlex>
      </>
   );
};
